import axios from "@/configuration/axios";
import cognito from "@/configuration/cognito";
import env from "@/configuration/env";
import loading from "@/configuration/loading";
import sentry from "@/configuration/sentry";

export default {
  init: async () => {
    await env.init();
    await loading.init();
    await axios.init();
    await cognito.init();
    await sentry.init();
  },
};
